import {Component, Input, OnInit, Output} from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'pr-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

    @Input()
    color: 'green' | 'blue' | 'red' | 'black';

    @Input()
    title: string;

    @Output()
    onClick = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }

    buttonClick() {
        this.onClick.emit(null);
    }

}
